import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Action               from "dashboard/dist/Core/Action";
import Status               from "dashboard/dist/Core/Status";
import Graph                from "Utils/Graph";
import GraphType            from "Utils/Entity/GraphType";

// Partials
import ReportFilters        from "../Partials/ReportFilters"
import ReportGraph          from "../Partials/ReportGraph";
import ReportTable          from "../Partials/ReportTable";

// Components
import CampaignSend         from "Components/Admin/Campaign/CampaignSend";
import Main                 from "dashboard/dist/Components/Main";
import Header               from "dashboard/dist/Components/Header";
import ActionList           from "dashboard/dist/Components/ActionList";
import Content              from "dashboard/dist/Components/Content";
import InputField           from "dashboard/dist/Components/InputField";
import Downloader           from "dashboard/dist/Components/Downloader";

// APIs
import {
    MeetingReport, Coach,
} from "Utils/API";

// Actions
import {
    fetchMeetingData, fetchMeetingGraph, fetchMeetingEmails,
} from "Actions/Admin/Report/MeetingActions";

// Styles
import "Styles/Components/App/Report.css";



/**
 * The Meeting Report Page
 */
class MeetingPage extends React.Component {
    // The Initial Data
    initialFilters = {
        graphType   : GraphType.COURSES,
        status      : 0,
        programType : 0,
        mode        : 0,
        courseID    : 0,
        programID   : 0,
        strechID    : 0,
        coachID     : 0,
        coachName   : "",
        period      : 0,
        fromDate    : "",
        toDate      : "",
    }

    // The Current State
    state = {
        filters : { ...this.initialFilters },
        action  : Action.get(),
        elemID  : 0,
        users   : [],
        graph   : 0,
    }



    /**
     * Load the Data
     * @returns {Void}
     */
    componentDidMount() {
        if (!this.props.data.loaded) {
            this.props.fetchMeetingData();
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        const filters = GraphType.handleFilter(this.state, name, value);
        if (GraphType.shouldFetchFilters(name)) {
            this.props.fetchMeetingData(filters, false);
        }
        this.setState({ filters });
    }

    /**
     * Handles the Report Filter
     * @returns {Promise}
     */
    handleFilter = async () => {
        const { graph, filters } = this.state;
        await this.props.fetchMeetingGraph(filters);
        this.setState({ graph : graph + 1 });
    }



    /**
     * Starts an Action
     * @param {Object} action
     * @param {Number} elemID
     * @returns {Promise}
     */
    startAction = async (action, elemID) => {
        let users = [];
        if (action.isCampaign) {
            users = await this.props.fetchMeetingEmails({ ...this.state.filters, elemID });
        }
        this.setState({ action, elemID, users });
    }

    /**
     * Ends an Action
     * @returns {Void}
     */
    endAction = () => {
        this.startAction(Action.get(), 0);
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { route, data                           } = this.props;
        const { filters, action, elemID, users, graph } = this.state;

        const hideFilter = GraphType.getHideFilters(filters.graphType);

        return <Main>
            <Header message="REPORTS_MEETINGS" icon="meeting" route={route}>
                <ActionList data={data} onAction={this.startAction} />
            </Header>
            <Content>
                <ReportFilters
                    type="MEETINGS"
                    data={data}
                    filters={filters}
                    onChange={this.handleChange}
                    onFilter={this.handleFilter}
                >
                    <InputField
                        type="select"
                        name="status"
                        label="REPORTS_MEETING_STATUS"
                        value={filters.status}
                        onChange={this.handleChange}
                        options={Status.getFemSelect("MEETING")}
                        noneText="GENERAL_ALL"
                        withNone
                        noMargin
                        shrinkLabel
                        labelInside
                    />

                    <InputField
                        isHidden={hideFilter.coaches}
                        name="coachName"
                        label="COACHES_SINGULAR"
                        suggestID="coachID"
                        suggestFetch={Coach.search}
                        suggestNone="COACHES_NONE_AVAILABLE"
                        value={filters.coachName}
                        onChange={this.handleChange}
                        noMargin
                        shrinkLabel
                        labelInside
                    />
                </ReportFilters>

                <ReportGraph
                    data={data}
                    graph={graph}
                    dataType={Graph.DATA_AMOUNT}
                />
                <ReportTable
                    data={data}
                    startAction={this.startAction}
                />
            </Content>

            <Downloader
                download={action.isExport}
                source={MeetingReport.export(filters)}
                onLoad={this.endAction}
            />
            <Downloader
                download={action.isDownload}
                source={MeetingReport.download({ ...filters, elemID })}
                onLoad={this.endAction}
            />
            <CampaignSend
                open={action.isCampaign}
                users={users}
                onClose={this.endAction}
                onSubmit={this.endAction}
            />
        </Main>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchMeetingData   : PropTypes.func.isRequired,
        fetchMeetingGraph  : PropTypes.func.isRequired,
        fetchMeetingEmails : PropTypes.func.isRequired,
        data               : PropTypes.object.isRequired,
        route              : PropTypes.string.isRequired,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            data : state.meetingReport,
        };
    }
}

export default connect(MeetingPage.mapStateToProps, {
    fetchMeetingData, fetchMeetingGraph, fetchMeetingEmails,
})(MeetingPage);
